<template>
  <div>
    <div class="banner">
      <Head></Head>
      <div class="topT">
        <div class="leftC">
          <div class="bTitle">码客通名片小程序</div>
          <div class="sTitle">AI智能获客营销系统</div>
          <div class="tyBtn">立即体验</div>
        </div>
        <div class="rightImg"></div>
      </div>
    </div>
    <div class="flowPool">
      <div class="cards">
        <div class="cList" :class="[index == activeIndex ? 'active' : '']" @click="tabIndex(index)"
          v-for="(item, index) in cards" :key="index">{{item.name}}</div>
      </div>
      <!-- <div class="title">多渠道获客触达 快速构建私域流量池</div> -->
      <div class="content" v-if="activeIndex == 0">
        <div class="leftinfo">
          <div class="ft">懂营销的名片</div>
          <div class="fc">码客通名片小程序，官方认证平台出品，为每一位顾客、销售达人打造专属电子名片，依托电子名片产品，梳理品牌形象，强化品牌认知，助力企业营销</div>
        </div>
        <div class="rightinfo">
          <img class="pollImg" src="../../assets/images/core1@2x.png" alt="">
          <img class="core01" :class="{'current': cardClass}" src="../../assets/images/core01@2x.png" alt="">
          <img class="core001" :class="{'current1': cardClass}" src="../../assets/images/core001@2x.png" alt="">
          <img class="core0001" :class="{'current2': cardClass}" src="../../assets/images/core0001@2x.png" alt="">
          <div class="btns">
            <div :class="[index == btnIndex ? 'btn2' : 'btn1']" v-for="(item, index) in btns" :key="index"
              @click="tabBtn(index)">
              {{item.name}}
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="activeIndex == 1">
        <div class="leftinfo">
          <div class="ft">会说话的名片</div>
          <div class="fc">名片可轻松设计展示，让您的个人形象更加饱满、企业形象更加高端大气，产品信息更加丰富立体，客户可全方位了解。</div>
        </div>
        <div class="rightinfo1">
          <img class="sh1" src="../../assets/images/sh1@2x.png" alt="">
          <img class="sh2" :class="{'shcard': cardClass1}" src="../../assets/images/sh2@2x.png" alt="">
          <div class="tabPic" v-if="flag">
            <img class="sh3" src="../../assets/images/sh3@2x.png" alt="">
            <img class="sh4" src="../../assets/images/sh4@2x.png" alt="">
          </div>
          <div class="tabPic" v-if="!flag">

            <img class="sh4" src="../../assets/images/sh4@2x.png" alt="">
            <img class="sh3" src="../../assets/images/sh3@2x.png" alt="">
          </div>
          <img class="sh5" :class="{'shcard1': cardClass1}" src="../../assets/images/sh5@2x.png" alt="">
          <div class="imgs">
            <img @click="tabImg(index)" v-for="(item, index) in 6" :key="index" class="sh6"
              :src="index == imgIndex ? require('../../assets/images/sh6@2x.png') : require('../../assets/images/sh7@2x.png')"
              alt="">
          </div>

          <img class="sh8" :class="{'shcard2': cardClass1}" src="../../assets/images/sh8@2x.png" alt="">
        </div>
      </div>
      <div class="content" v-if="activeIndex == 2">
        <div class="leftinfo">
          <div class="ft">促成交的名片</div>
          <div class="fc">码客通名片基于微信生态；客户画像更全面，客户分层更精细，客户触达更精准，高效管理客户，大大提高客户转化率，实现精准获客营销。</div>
        </div>
        <div class="rightinfo2">
          <img class="cj1" src="../../assets/images/cj1@2x.png" alt="">
          <img class="cj2" :class="{'cjcard1': cardClass2}" src="../../assets/images/cj2@2x.png" alt="">
          <img class="cj3" :class="{'cjcard2': cardClass2}" src="../../assets/images/cj3@2x.png" alt="">
          <img class="cj4" :class="{'cjcard3': cardClass2}" src="../../assets/images/cj4@2x.png" alt="">
          <div class="promote" :class="{'showDiv' : flag1}">
            <span class="text">客户转化率提升</span>
            <span class="num">90%</span>
          </div>
          <div class="accurate" :class="{'showDiv' : flag1}">
            <span class="text">客户触达精准率</span>
            <span class="num">86%</span>
          </div>
        </div>
      </div>
    </div>
    <div class="core">
      <div class="title">核心功能介绍</div>
      <div class="cores">
        <div @click="tabCore(index)" class="list" :class="[index == coreIndex ? 'coreactive' : 'coreactive1']"
          v-for="(item, index) in coreList" :key="index">
          <div class="title">
            <div class="name" :style="{'color': index == coreIndex ? '#F7F7F7' : '#1F2329' }">{{item.name}}</div>
            <img v-if="index == 1"
              :src="index == coreIndex ? require('../../assets/images/ICON01@2x.png') :  require('../../assets/images/ICON1@2x.png')"
              alt="">
            <img v-if="index == 0"
              :src="index == coreIndex ? require('../../assets/images/ICON2@2x.png') :  require('../../assets/images/ICON02@2x.png')"
              alt="">
          </div>

          <div class="text" :style="{'color': index == coreIndex ? '#F7F7F7' : '#7A889C' }">{{item.text}}</div>
        </div>
      </div>
    </div>
    <BNavigation></BNavigation>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Head from './Head'
  import BNavigation from './bNavigation'
  export default {
    data() {
      return {
        cardClass: false,
        cardClass1: false,
        imgIndex: 0,
        flag: false,
        flag1: false,
        btnIndex: 0,
        coreIndex: 0,
        activeIndex: 0,
        btns: [{
          name: '转发名片'
        }, {
          name: '交换名片'
        }],
        coreList: [{
          name: '获客营销',
          text: '通过电子名片能实现名片访客查看线索数，自动同步客户资料与跟进信息。可轻松分析获客数据，帮助销售分析洞察转化效果'
        }, {
          name: '裂变营销',
          text: '商品多样化的微商城，商城可以满足企业不同需求，优惠券、裂变活动、拼团、推广商品等裂变工具拓展获客渠道，每个人都是营销能手'
        }],
        cards: [{
          'name': '懂营销的名片'
        }, {
          'name': '会说话的名片',
          img: require('../../assets/images/core1@2x.png')
        }, {
          'name': '促成交的名片'
        }]
      }
    },
    components: {
      Head,
      BNavigation
    },
    methods: {
      tabImg(index) {
        if (index > 1) {
          return
        }
        this.imgIndex = index
        this.flag = !this.flag
      },
      tabBtn(index) {
        this.btnIndex = index
      },
      tabCore(index) {
        this.coreIndex = index
      },
      tabIndex(index) {
        this.activeIndex = index
        if (index == 0) {
          this.cardClass = true
          this.cardClass1 = false
          this.cardClass2 = false
          this.flag = false
        } else if (index == 1) {
          this.cardClass = false
          this.cardClass1 = true
          this.cardClass2 = false
          this.flag = false
        } else if (index == 2) {
          this.flag1 = true
          this.cardClass = false
          this.cardClass1 = false
          this.cardClass2 = true

        }

        if (index != 0) {
          this.btnIndex = 0
        }
        setTimeout(() => {
          if (index == 0) {
            this.btnIndex = 1
          }
        }, 2000)
      }
    }
  }
</script>

<style scoped>
  @media (max-width: 1500px) {
    .bottleneck {
      width: 1440px;
    }
  }

  @media (min-width: 1500px) {
    .bottleneck {
      width: 1640px;
    }
  }

  .banner {
    width: 100%;
    height: 620px;
    background: url('../../assets/images/scrm_bg@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .topT {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 100px;
    box-sizing: border-box;
  }

  .leftC {
    width: 524px;
    margin-right: 183px;
  }

  .bTitle {
    font-size: 42px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1E232A;
    line-height: 70px;
    letter-spacing: 1px;
  }

  .sTitle {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1E232A;
    line-height: 36px;
    margin: 27px 0 63px;
  }

  .tyBtn {
    width: 154px;
    height: 52px;
    background: linear-gradient(270deg, #14E1A0 0%, #02B4E0 100%);
    border-radius: 26px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rightImg {
    width: 712px;
    height: 406px;
    background: url('../../assets/images/cardImg@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .bottleneck {
    height: 800px;
    margin: 0 auto;
    padding-top: 100px;
  }

  .bottleneck>.title,
  .flowPool>.title {
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1F2329;
    line-height: 40px;
    text-align: center;
  }

  .bottleneck .content {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    /* justify-content: flex-start; */
  }

  .bottleneck .content>div {
    width: 33%;
    text-align: center;
  }

  .bottleneck .content>div img {
    margin-top: 40px;
  }

  .it {
    margin-top: 40px;
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1F2329;
    line-height: 40px;
  }

  .ic {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #36444D;
    line-height: 30px;
  }

  .flowPool {
    height: 780px;
    margin: 0 auto;
    background: linear-gradient(180deg, #FBFCFC 0%, #FFFFFF 100%);
    padding-top: 100px;
    box-sizing: border-box;
  }

  .flowPool .content {
    margin-top: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flowPool .content .leftinfo {
    width: 560px;
  }

  .flowPool .ft {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1F2329;
    line-height: 40px;
    position: relative;
  }

  .flowPool .fc {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #36444D;
    line-height: 30px;
    margin-top: 70px;

  }

  .flowPool .ft::after {
    content: '';
    width: 96px;
    height: 3px;
    background: linear-gradient(270deg, #14E1A0 0%, #02B4E0 100%);
    border-radius: 2px;
    position: absolute;
    bottom: -30px;
    left: 0px;
  }



  .cards {
    display: flex;
    justify-content: center;
  }

  .cList {
    width: 219px;
    height: 56px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #92A0B4;
    line-height: 34px;
    margin: 0 60px;
    padding-top: 20px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .active {
    width: 219px;
    height: 56px;
    background: url('../../assets/images/active@2x.png') top center no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #1F2329;
    line-height: 34px;
    padding-top: 20px;
    box-sizing: border-box;
  }

  .core {
    height: 663px;
    background-color: #F3F8F9;
    box-sizing: border-box;
    padding-top: 110px;
  }

  .core>.title {
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #1F2329;
    line-height: 84px;
    text-align: center;
  }

  .cores {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }

  .core .list {
    cursor: pointer;
    width: 600px;
    height: 306px;
    /* background: #FFFFFF; */
    border-radius: 26px;
    margin: 0 40px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 40px;
  }

  .core .list .name {
    font-size: 34px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 84px;
  }

  .coreactive {
    width: 600px;
    height: 306px;
    background: url('../../assets/images/aBg@2x.png') top center no-repeat;
    background-size: 100% 100%;
  }

  .coreactive1 {
    background: #FFFFFF;
  }

  .core .list .text {
    font-size: 18px;
    font-family: PingFang SC;
    color: #F7F7F7;
    line-height: 34px;
    margin-top: 40px;
  }

  .cores img {
    width: 92px;
    height: 92px;
  }

  .cores .list .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .rightinfo {
    width: 666px;
    height: 416px;
    position: relative;
  }

  .pollImg {
    width: 666px;
    height: 416px;
  }

  .core01 {
    width: 46px;
    height: 46px;
    position: absolute;
    right: 265px;
    top: 0px;
  }

  .current {
    opacity: 1;
    animation: 2s fadein;
  }

  @keyframes fadein {
    0% {
      width: 46px;
      height: 46px;
    }

    50% {
      width: 66px;
      height: 66px;
    }

    100% {
      width: 46px;
      height: 46px;
    }
  }

  .core001 {
    width: 66px;
    height: 66px;
    position: absolute;
    top: 150px;
    right: 35px;
  }

  .current1 {
    opacity: 1;
    animation: 2s fadein1;
  }

  @keyframes fadein1 {
    0% {
      width: 66px;
      height: 66px;
    }

    50% {
      width: 88px;
      height: 88px;
    }

    100% {
      width: 66px;
      height: 66px;
    }
  }

  .core0001 {
    width: 54px;
    height: 54px;
    position: absolute;
    top: 250px;
    left: 235px;
  }

  .current2 {
    opacity: 1;
    animation: 2s fadein2;
  }

  @keyframes fadein2 {
    0% {
      width: 54px;
      height: 54px;
    }

    50% {
      width: 74px;
      height: 74px;
    }

    100% {
      width: 54px;
      height: 54px;
    }
  }



  .btns {
    position: absolute;
    bottom: 60px;
    right: 70px;
    display: flex;
    justify-content: center;
  }

  .btns>div {
    width: 136px;
    height: 44px;
    margin: 0 10px;
    font-size: 18px;
    font-family: PingFang SC;
    border-radius: 22px;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
  }

  .btn1 {
    color: #B0BCBC;
    background: #FFFFFF;
    border: 1px solid #E9F0F0;
  }

  .btn2 {
    background: #459FFD;
    color: #FFFFFF;
  }

  .rightinfo1 {
    width: 614px;
    height: 400px;
    position: relative;
  }

  .sh1 {
    width: 614px;
    height: 400px;
  }

  .sh2 {
    width: 46px;
    height: 46px;
    position: absolute;
    top: -15px;
    right: 140px;
  }

  .shcard {
    opacity: 1;
    animation: 2s fadein3;
  }

  @keyframes fadein3 {
    0% {
      width: 46px;
      height: 46px;
    }

    50% {
      width: 66px;
      height: 66px;
    }

    100% {
      width: 46px;
      height: 46px;
    }
  }

  .tabPic {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 45px;
    right: 45px;
  }

  .sh3 {
    width: 139px;
    height: 99px;
    margin: 0 10px;
    /* position: absolute;
    top: 45px;
    right: 150px; */
  }

  .sh4 {
    width: 85px;
    height: 85px;
     margin: 0 10px;
   /* position: absolute;
    top: 45px;
    right: 45px; */
  }

  .sh5 {
    width: 60px;
    height: 60px;
    position: absolute;
    top: 115px;
    left: 245px;
  }

  .shcard1 {
    opacity: 1;
    animation: 2s fadein4;
  }

  @keyframes fadein4 {
    0% {
      width: 60px;
      height: 60px;
    }

    50% {
      width: 80px;
      height: 80px;
    }

    100% {
      width: 60px;
      height: 60px;
    }
  }

  .imgs {
    position: absolute;
    top: 150px;
    left: 305px;
  }

  .imgs>img {
    margin: 0 3px;
  }

  .sh6 {
    width: 38px;
    height: 32px;
  }

  .sh7 {
    width: 38px;
    height: 32px;
  }

  .sh8 {
    width: 62px;
    height: 62px;
    position: absolute;
    top: 265px;
    right: -20px;
  }

  .shcard2 {
    opacity: 1;
    animation: 2s fadein5;
  }

  @keyframes fadein5 {
    0% {
      width: 62px;
      height: 62px;
    }

    50% {
      width: 82px;
      height: 82px;
    }

    100% {
      width: 62px;
      height: 62px;
    }
  }

  .rightinfo2 {
    width: 592px;
    height: 406px;
    position: relative;
  }

  .cj1 {
    width: 592px;
    height: 406px;
  }

  .cj2 {
    width: 114px;
    height: 46px;
    position: absolute;
    top: 60px;
    right: 240px;
  }

  .cjcard1 {
    opacity: 1;
    animation: 2s fadein6;
  }

  @keyframes fadein6 {
    0% {
      width: 114px;
      height: 46px;
    }

    50% {
     width: 154px;
     height: 66px;
    }

    100% {
      width: 114px;
      height: 46px;
    }
  }

  .cj3 {
    width: 108px;
    height: 50px;
    position: absolute;
    top: 180px;
    right: 200px;
  }

  .cjcard2 {
    opacity: 1;
    animation: 2s fadein7;
  }

  @keyframes fadein7 {
    0% {
      width: 108px;
      height: 50px;
    }

    50% {
     width: 148px;
     height: 70px;
    }

    100% {
      width: 108px;
      height: 50px;
    }
  }

  .cj4 {
    width: 120px;
    height: 50px;
    position: absolute;
    bottom: 50px;
    right: 300px;
  }

  .cjcard3 {
    opacity: 1;
    animation: 2s fadein8;
  }

  @keyframes fadein8 {
    0% {
     width: 120px;
     height: 50px;
    }

    50% {
     width: 160px;
     height: 70px;
    }

    100% {
     width: 120px;
     height: 50px;
    }
  }

  .promote, .accurate {
    width: 250px;
    height: 58px;
    background: #FDFDFD;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 10px 2px #e9e9e9;
  }

  .promote {
    position: absolute;
    top: 120px;
    left: 0px;
  }

  .accurate {
    position: absolute;
    bottom: 100px;
    right: 0px;
  }

  .promote .text, .accurate .text {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #989FA9;
  }

  .promote .num {
    font-size: 22px;
    font-family: DIN;
    font-weight: bold;
    color: #459FFD;
  }

  .accurate .num {
    font-size: 22px;
    font-family: DIN;
    font-weight: bold;
    color: #00D6B5;
  }

  .showDiv {
    opacity: 1;
    animation: 3s xsdiv;
  }

  @keyframes xsdiv {
    0% {
       opacity: 0;
    }

    100% {
       opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/Card.vue